import PropTypes from 'prop-types';
import React from 'react';

import Firebase from './src/firebase/firebase';

import { ContextProviderComponent } from './src/components/Context/Context';

console.log('GATSBY_ENV', process.env.GATSBY_ENV);

if (process.env.GATSBY_ENV !== 'development' && process.env.GATSBY_ENV !== 'preview') {
  console.log = () => {};
}

const activateOptimize = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'optimize.activate' });
};

export const onRouteUpdate = () => {
  activateOptimize();
};

export const wrapRootElement = ({ element, props }) => (
  <Firebase
    {...props}
  >
    <ContextProviderComponent>
      {element}
    </ContextProviderComponent>
  </Firebase>
);

wrapRootElement.propTypes = {
  element: PropTypes.any.isRequired,
  props: PropTypes.any.isRequired,
};
